module.exports = __webpack_public_path__ + "static/media/circle-arrow-right-blue.ffe44c82.svg";